import { collection, getDocs, doc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../Firebase";

export const getJobOpenings = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "job_openings"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });
    return list;
  } catch (error) {
    console.error("Error fetching job openings from Firestore: ", error);
    throw error;
  }
};

export const saveJobOpening = async (op) => {
  try {
    const docRef = doc(db, "job_openings", op.id);
    await setDoc(docRef, op, { merge: true });
  } catch (error) {
    console.error("Error saving job opening to Firestore: ", error);
    throw error;
  }
};

export const deleteJobOpening = async (id) => {
  try {
    const docRef = doc(db, "job_openings", id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Error deleting job opening: ", error);
    throw error;
  }
};

export const getJobApplications = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "job_applications"));
    const list = [];
    querySnapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });
    list.sort((a, b) => b.id.localeCompare(a.id));
    return list;
  } catch (error) {
    console.error("Error fetching job applications from Firestore: ", error);
    throw error;
  }
};

export const saveJobApplication = async (app) => {
  try {
    const docRef = doc(db, "job_applications", app.id);
    await setDoc(docRef, app, { merge: true });
  } catch (error) {
    console.error("Error saving job application to Firestore: ", error);
    throw error;
  }
};

export const deleteJobApplication = async (id) => {
  try {
    const docRef = doc(db, "job_applications", id);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Error deleting job application: ", error);
    throw error;
  }
};
